module.exports = __webpack_public_path__ + "img/fxbulls.78d2c921.jpg";